import { useStoreMap } from 'effector-react'
import { driverModel } from '~/entities/Driver'
import { Button } from '~/shared/ui/Buttons'
import { ErrorSmallIcon, SuccessSmallIcon } from '~/shared/ui/icons'
import { EmailWrapper, Field, FieldWrapper, Label } from './styled'

type EmailProps = {
  onChange: () => void
}

export function Email({ onChange }: EmailProps) {
  const email = useStoreMap(driverModel.$driver, (driver) => driver?.getEmail())
  const emailVerifiedAt = useStoreMap(driverModel.$driver, (driver) =>
    driver?.getEmailVerifiedAt(),
  )

  return (
    <>
      <Label>Email</Label>

      <FieldWrapper>
        {email ? (
          <>
            <EmailWrapper>
              <Field data-testid='field-driver-email'>{email}</Field>
              {emailVerifiedAt ? <SuccessSmallIcon /> : <ErrorSmallIcon />}
            </EmailWrapper>
            <Button
              variant='textLink'
              onClick={onChange}
              contentProps={{ style: { padding: '0' } }}
            >
              Изменить
            </Button>
          </>
        ) : (
          <Button fullWidth variant='lightSteelBlueBorder' onClick={onChange}>
            Добавить почту
          </Button>
        )}
      </FieldWrapper>

      {/*<Typography color='mutedText.main' fontSize={14} mb='8px'>*/}
      {/*  На Email приходят счета, выписки и чеки*/}
      {/*</Typography>*/}
    </>
  )
}
